import InitialState from './InitialState';
import {KB_CATEGORY_LIST, KB_FAQ_LIST, KB_ITEM_LIST, KB_IW_ITEM_LIST} from "../actions/ActionTypes";

const  KBReducer = (state = InitialState.knowledgeBase, action) => {
    switch (action.type) {
        case KB_CATEGORY_LIST: {
            return {
                ...state,
                categories: action.kbCategories
            }
        }

        case KB_ITEM_LIST: {
            return {
                ...state,
                itemList: action.itemList
            }
        }

        case KB_FAQ_LIST: {
            return {
                ...state,
                faqList: action.faqList
            }
        }

        case KB_IW_ITEM_LIST: {
            return {
                ...state,
                iwItemList: action.iwItemList
            }
        }

        default:
            return state;
    }
};
export default KBReducer;



// WEBPACK FOOTER //
// ./src/reducers/KBReducer.js